import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Navbar,
  Collapse,
  Nav,
  NavbarBrand,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Button,
} from "reactstrap";
import { ReactComponent as LogoWhite } from "../assets/images/logos/pedaylogowhite.svg";
import user1 from "../assets/images/users/user1.jpg";
import getPrivilegeList from "../peday/PrivilegeList";

const Header = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const navigate = useNavigate();
  const privilegeList = getPrivilegeList();

  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const Handletoggle = () => setIsOpen(!isOpen);

  const showMobilemenu = () => {
    document.getElementById("sidebarArea").classList.toggle("showSidebar");
  };

   // Get username from localStorage
  const username = localStorage.getItem("username") || "User";
  const userId = localStorage.getItem("userId") || "-";



  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  return (
    // <Navbar expand="md" dark style={{ backgroundColor: "#024c8c" }}>
    <Navbar
  expand="md"
  dark
  style={{
    backgroundColor: "#024c8c",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)"
  }}
>
      <div className="d-flex align-items-center">
        <NavbarBrand href="/" className="d-lg-none">
          <LogoWhite />
        </NavbarBrand>
        <Button
          color="primary"
          className="d-lg-none"
          onClick={showMobilemenu}
        >
          <i className="bi bi-list"></i>
        </Button>
      </div>

      <div className="hstack gap-2">
        <Button
          color="primary"
          size="sm"
          className="d-sm-block d-md-none"
          onClick={Handletoggle}
        >
          {isOpen ? (
            <i className="bi bi-x"></i>
          ) : (
            <i className="bi bi-three-dots-vertical"></i>
          )}
        </Button>
      </div>

      <Collapse navbar isOpen={isOpen}>
        <Nav className="me-auto" navbar></Nav>
        <Dropdown isOpen={dropdownOpen} toggle={toggle}>
          <DropdownToggle
      style={{
        backgroundColor: "#024c8c",
        borderColor: "#024c8c",
        transition: "all 0.3s ease",
      }}
      onMouseEnter={(e) =>
        (e.currentTarget.style.backgroundColor = "#013a6b")
      }
      onMouseLeave={(e) =>
        (e.currentTarget.style.backgroundColor = "#024c8c")
      }
    >
  <img
    src={user1}
    alt="profile"
    className="rounded-circle"
    width="30"
  />
</DropdownToggle>
          <DropdownMenu>
            {/* <DropdownItem header>Info</DropdownItem> */}
            <DropdownItem header>Hello, {username}</DropdownItem>
            <DropdownItem>Edit Profile</DropdownItem>
            <DropdownItem divider />
            {privilegeList.privilegeTabView && (
            <DropdownItem onClick={() => navigate("/Privilege")}> <i className="bi bi-shield-lock me-2"></i> Privilege</DropdownItem>
            )}
             {privilegeList.addEmployeeTabView && (
            <DropdownItem onClick={() => navigate("/employeeform")}><i className="bi bi-person-plus me-2"></i> Add Employee</DropdownItem>
             )}
            <DropdownItem onClick={() => navigate("/AddLender")}><i className="bi bi-bank me-2"></i> Add Lender</DropdownItem>
            {privilegeList.reportingProfileView && (
            <DropdownItem onClick={() => navigate("/reporting")}><i className="bi bi-file-earmark-text me-2"></i>Reporting</DropdownItem>
            )}
             {privilegeList.payoutRequestTabView && (
             <DropdownItem onClick={() => navigate("/payoutrequest")}> <i className="bi bi-wallet2 me-2"></i>Payout Request</DropdownItem>
            )}
            {privilegeList.blockTabView && (
            <DropdownItem onClick={() => navigate("/Blocked")}><i className="bi bi-geo-alt-fill me-2"></i> Blocked Areas </DropdownItem>
            )}
            {privilegeList.breButtonView && (
            <DropdownItem onClick={() => navigate("/BreButton")}><i className="bi bi-cpu-fill me-2"></i> Rule Engine </DropdownItem>
            )}
             {privilegeList.appStatusView && (
            <DropdownItem onClick={() => navigate("/StepStatus")}><i className="bi-gear-fill"></i> App Status </DropdownItem>
            )}

             <DropdownItem divider />
             
            <DropdownItem onClick={handleLogout}><i className="bi bi-box-arrow-right me-2"></i>Logout</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Collapse>
    </Navbar>
  );
};

export default Header;
